module.exports = "/_next/static/images/7519454b39a5bdaa4b9edac123665099-office@0.5x.jpg.webp";